import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { FieldType } from '@ngx-formly/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'sc-field-checkbox',
  templateUrl: './field-checkbox.component.html',
  styleUrls: ['./field-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldCheckboxComponent extends FieldType implements OnInit {
  @ViewChild(MatCheckbox) checkbox!: MatCheckbox;
  defaultOptions = {
    templateOptions: {
      hideFieldUnderline: true,
      indeterminate: false,
      floatLabel: 'always',
      hideLabel: true,
      align: 'start', // start or end
      color: 'accent' // workaround for https://github.com/angular/components/issues/18465
    }
  };

  public checked$: Observable<boolean>;

  public ngOnInit() {
    if (!this.formControl.value) {
      this.formControl.setValue('N');
    }

    this.checked$ = this.formControl.valueChanges.pipe(
      startWith(this.formControl.value),
      map(term => term === 'Y')
    );
  }

  public onContainerClick(event: MouseEvent): void {
    this.checkbox.focus();
    this.onContainerClick(event);
  }

  public onChange(checked: boolean) {
    const value = checked ? 'Y' : 'N';
    this.formControl.setValue(value);
    this.formControl.markAsTouched();
  }
}
